export default __webpack_public_path__ + "static/illo-toggl-devices-d06587f566d4b463024dab3bfb702d9a.png";